/**
 * 获取URL 参数对象
 * @param query
 * @returns {{}}
 */
const getRequestParams = (query: string) => {
    let search = query.trim().replace(/^[?#&]/, '') || window.location.search.substring(1);
    return search ? JSON.parse('{"' + search.replace(/&/g, '","').replace(/=/g, '":"') + '"}', function (key, value) {
        return key === '' ? value : decodeURIComponent(value);
    }) : {};
};

/**
 * @description: 在url上拼接from参数
 * @param    {string}  url  一个url路径参数
 * @return:  {string}       拼接后的路径参数
 */
const formatFrom = (url: string): string => {
    if (!url || typeof url !== 'string') {
        return url = '';
    }

    const searchObj = getRequestParams(window.location.search || '');
    const { from } = searchObj || {};

    const searchPos = url.indexOf('?');
    const hashPos = url.indexOf('#');
    const beforeHash = url.substring(0, hashPos);
    const afterHash = url.substring(hashPos);
    const hasSearch = (searchPos !== -1);
    const hasHash = (hashPos !== -1);

    // 有两种情况，没有search且没有hash，没有search但有hash
    if (!hasSearch) {
        if (!hasHash) {
            return `${url}?from=${from}`;
        }

        return `${beforeHash}?from=${from}${afterHash}`;
    }

    // 有两种情况，有search且有hash，有search但没有hash
    if (hasHash) {
        return `${beforeHash}&from=${from}${afterHash}`;
    }

    return `${url}&from=${from}`;
};

/**
 * 获取URL 参数对象格式化处理协议  把http: https:去掉
 * @param website
 * @returns string
 */
const formatProtocol = (website?: string): string => {
    if (!website) {
        return '';
    }
    // eslint-disable-next-line
    return website.replace(/^(http|https)\:/, '');
};

/**
 * 人脸展示身份证号脱敏 只展示前三位末三位中间用*代替
 * @param idCard
 * @returns string
 */
const formatIdCard = (idCard: string): string => idCard.replace(/^(\d{3})\d+(\d{2}[0-9a-zA-Z])$/, '$1************$2');

/**
 * 人脸展示身份证号脱敏 只展示前一位末一位中间用*代替
 * @param idCard
 * @returns string
 */
const newFormatIdCard = (idCard: string): string => idCard.replace(/^(\d)\d+([0-9a-zA-Z])$/, '$1************$2');

/**
 * 人脸展示姓名脱敏 展示为：**末一个字
 * @param name
 * @returns string
 */
const formatName = (name: string): string => name.replace(/^\S+(\S)/, '**$1');

/**
 * 人脸展示姓名脱敏 展示规则为：4字及以内只展示最后一个字其他都展示*；5-7字前两个字展示为*后面的正常展示；8及以上前两字展示中间四位*后面正常展示。
 * @param name
 * @returns string
 */
const newFormatName = (name: string): string => {
    const length = name.length;
    if (length < 4) {
        return name.replace(/^\S(\S+)/, '*$1');
    } else if (length < 7) {
        return name.replace(/^\S{2}(\S+)/, '**$1');
    } else {
        return name.replace(/^(\S{2})\S{4}(\S+)/, '$1****$2');
    }
};

/**
 * 金额展示带千分位
 * @returns string
 */
const formatMoney = (value: string | number): string => {
    if (!value && value !== 0) return '';
    return `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

/**
 * 去掉字符串中的空格
 * @returns string
 */
const handleSpace = (str: string): string => str.replace(/\s/g, '')

/**
 * 银行卡号、手机号等输入框每隔几位加空格 例如：sourceString=18323236767 separatorArray=[3,4,4] 返回结果是'183 2323 6767'
 * @returns string
 */
const addSpaceSeparator = (sourceString: string | number, separatorArray: number[]): string => {
    if (!sourceString) return '';

    const str = String(sourceString).replace(/\s/g, '');
    if (!Array.isArray(separatorArray) || separatorArray.length < 1) return str;

    const strLength = str.length;
    const arrLenth = separatorArray.length;
    const temp: string[] = [];
    let i = 0;
    let start = 0;
    let end = 0;
    while (i < arrLenth) {
        end = start + separatorArray[i];
        temp[i] = str.slice(start, end);
        i += 1;
        start = end;
    }
    if (start < strLength) temp[i] = str.slice(start, strLength);

    return temp.join(' ').trim();
};

/**
 * 金额展示处理，超过一万时要按万元为单位展示
 * @returns string
 */
const formatBankLimit = (limit: string | number): string => {
    const limitNumber = Number(limit);
    if (!limitNumber) return '0';

    return limitNumber >= 10000 ? `${limitNumber / 10000}万` : `${limit}`;
}

/**
 * 自定义函数名：PrefixZero 给数字前加0
 *  @param num： 被操作数， length：固定的总位数
 *  TODO: 不知道为什么这里没用padStart方法来实现自动补0效果  本次修改先不动 一方面是测试时间 一方面是调用这个方法的页面已经下线 考虑删除对应文件了
 */
const PrefixInteger = (num: number, length: number): string => (Array(length).join('0') + num).slice(-length);

/**
 * 给指定url设置指定参数
 * @param {*} url 设置url
 * @param {*} params 参数如
 * @returns 拼接好的url
 */
function setUrlParams(originUrl, params) {
    const url = new URL(originUrl);
    const origin = url.origin + url.pathname;
    const originHash = url.hash;
    const searchPos = originHash.indexOf('?');
    var hash = originHash;
    var search = url.search;
    // 判断hash是否存在query
    if (searchPos !== -1) {
        let hashList = originHash.split('?');
        hash = hashList[0];
        let afterHsah = hashList[1];
        search = search.length > 0 ? search + '&' + afterHsah : '?' + afterHsah;
    }
    // 获取Params
    const originParams = search ? getRequestParams(search) : {};
    // 处理异常参数
    if (typeof (params) !== 'object') params = null;
    // 拼接成最新的Params
    var newParems = { ...originParams, ...params };
    // 拼接参数的的字符串
    let paramsStr = '';
    const arr: any[] = [];
    Object.keys(newParems).forEach((key) => {
        if (typeof newParems[key] === 'object') {
            arr.push(`${key}=${encodeURIComponent(JSON.stringify(newParems[key]))}`);
        } else if (typeof newParems[key] !== 'undefined') {
            arr.push(`${key}=${encodeURIComponent(newParems[key])}`);
        }
    });
    paramsStr = arr.length ? '?' + arr.join('&') : '';
    return `${origin}${paramsStr}${hash}`;
}

export {
    formatFrom,
    formatProtocol,
    formatIdCard,
    newFormatIdCard,
    formatName,
    newFormatName,
    formatMoney,
    handleSpace,
    addSpaceSeparator,
    formatBankLimit,
    PrefixInteger,
    setUrlParams,
}